import { Typography } from '@mui/material'
import { StyledPageContent } from '@/styles/global'

import { ContentWrapper } from './styles'

export const PageUnderConstruction = () => (
  <StyledPageContent>
    <ContentWrapper>
      <Typography variant="h4">🚧 Page under construction.</Typography>
    </ContentWrapper>
  </StyledPageContent>
)
